import { Buttons } from "src/components/atoms/Buttons";
import { ReactComponent as IconFire } from "../../styles/assets/svg/icon_fire.svg";
import { ReactComponent as IconNoimg } from "../../styles/assets/svg/icon_noImage.svg";
import { ReactComponent as IconLeftArrow } from "../../styles/assets/svg/icon_LeftChevron.svg";
import { ReactComponent as IconRightArrow } from "../../styles/assets/svg/icon_RightChevron.svg";
import { ReactComponent as IconEmptyDiet } from "../../styles/assets/svg/icon_emptyDiet.svg";
import { useEffect, useState } from "react";
import { ModalDietNote } from "src/components/molecules/ModalDietNote";
import dayjs from "dayjs";
import { ModalDatePicker } from "src/components/molecules/ModalDatePicker";
import { useLocation, useNavigate } from "react-router";
import { PageContainer } from "src/components/organisms/contents";
import Toast from "../myInfo/components/InfoToast";
import { useViewport } from "src/common/hooks/ViewPort";
import { useDietRegister } from "src/common/hooks/useDietRegister";
import { TopBackground } from "src/components/atoms/TopBackground/TopBackground";
import {
  ConHeader,
  titleText,
} from "src/components/atoms/MainHeaderBox/MainConHeader";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { PopupEmotion } from "src/components/atoms/PopupEmotion";

export const subtitleText = {
  fontSize: 14,
  fontWeight: 500,
  lineHeight: "20px",
  color: "var(--neutral-500, #737373)",
};
const largeNumberText = {
  fontSize: 32,
  fontWeight: 600,
  lineHeight: "44px",
  color: "var(--neutral-700, #404040)",
};

export const DietPage = () => {
  const navi = useNavigate();
  const location = useLocation() as {
    state?: { toast?: string; date?: string; complete?: boolean };
  };
  const { px } = useViewport();

  const today = dayjs().format("YYYY.MM.DD");

  const [open, setOpen] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<string>(today);
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const [toast, setToast] = useState<string | null>(null);
  const [completMedi, setCompletMedi] = useState<boolean>(false);
  const formattedDate = selectedDate.split(".").join("");

  /* 유저 정보 불러오기 */
  const { data: userInfo } = useUserRegister();

  /* 식단 불러오기 */
  const { data: dietData = [] } = useDietRegister(formattedDate);

  useEffect(() => {
    if (location.state?.toast) {
      setToast(location.state.toast);
      navi(".", { replace: true, state: {} });
    }
    if (location.state?.date) {
      setSelectedDate(dayjs(location.state?.date!).format("YYYY.MM.DD"));
      navi(".", { replace: true, state: {} });
    }
    if (location.state?.complete) {
      setCompletMedi(true);
      navi(".", { replace: true, state: {} });
    }
  }, [location.state, navi]);

  useEffect(() => {
    if (completMedi) {
      const timer = setTimeout(() => {
        setCompletMedi(false);
      }, 1000); // 1000ms = 1초

      return () => clearTimeout(timer); // cleanup
    }
  }, [completMedi]);

  const handlePrev = () => {
    setSelectedDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).subtract(1, "day").format("YYYY.MM.DD")
    );
  };

  const handleNext = () => {
    setSelectedDate((prev) =>
      dayjs(prev.replace(/\./g, "-")).add(1, "day").format("YYYY.MM.DD")
    );
  };

  const formatDate = (y: number, m: number, d: number) =>
    `${y}.${String(m).padStart(2, "0")}.${String(d).padStart(2, "0")}`;

  const recommendCalories = () => {
    if (!userInfo) return 0;

    const { gender, height, weight, birthyear } = userInfo;
    const currentYear = new Date().getFullYear();
    const age = currentYear - Number(birthyear);

    /* 기초대사량 계산 */
    const BMR =
      gender === "M"
        ? 293 -
          3.8 * age +
          456.4 * (Number(height) / 100) +
          10.12 * Number(weight)
        : 247 -
          2.67 * age +
          401.5 * (Number(height) / 100) +
          8.6 * Number(weight);

    // 활동계수 (기본값: 보통 활동)
    const activityFactor = 1.3;

    // 일일 권장 칼로리 (BMR × 활동계수)
    const totalCalories = Math.round(BMR * activityFactor);

    return totalCalories.toLocaleString();
  };

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 상단 배경 */}
        <TopBackground />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            position: "relative",
            zIndex: 1,
            paddingBottom: "70px",
          }}
        >
          {/* 헤더 */}
          <ConHeader
            title="식단"
            onClickArrow={() => navi("/")}
            onClickSetting={() => navi("/myInfo")}
            setIcon={false}
          />
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 0",
            }}
          >
            <IconArrow
              onClick={() => navi("/")}
              style={{ cursor: "pointer" }}
            />
            <div style={{ ...titleText, color: "white" }}>식단</div>
            <IconSetting
              onClick={() => navi("/myInfo")}
              style={{ cursor: "pointer" }}
            />
          </div> */}

          {/* 날짜 선택 */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 48,
              zIndex: 1,
              padding: 8,
              background: "var(--white, white)",
              boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              borderRadius: 999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 8px",
              }}
            >
              <IconLeftArrow
                style={{ cursor: "pointer" }}
                onClick={handlePrev}
              />
              <div
                style={{ ...titleText, fontWeight: 700, cursor: "pointer" }}
                onClick={() => setOpenCalendar(true)}
              >
                {selectedDate}
              </div>
              <IconRightArrow
                style={{ cursor: "pointer" }}
                onClick={handleNext}
              />
            </div>
            {/* 모달 */}
            {openCalendar && (
              <ModalDatePicker
                data={selectedDate}
                title="날짜"
                onClose={() => setOpenCalendar(false)}
                onConfirm={(year, month, day) => {
                  setSelectedDate(formatDate(year, month, day));
                  setOpenCalendar(false);
                }}
              />
            )}
          </div>

          {/* 일일 식단 */}
          <div
            style={{
              width: "100%",
              height: "100%",
              padding: 16,
              background: "var(--white, white)",
              boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              borderRadius: 16,
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <div style={titleText}>일일 식단 섭취 권장 칼로리</div>

            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  background: "#FFEDD6",
                  borderRadius: 16,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconFire />
              </div>

              <div
                style={{ display: "flex", alignItems: "flex-start", gap: 4 }}
              >
                <div style={largeNumberText}>{recommendCalories()}</div>
                <div style={{ ...subtitleText, paddingTop: 12 }}>Kcal</div>
              </div>
            </div>
          </div>

          <Buttons
            size="lg-br"
            layout="defaultGradient"
            type="button"
            label="+ 식단 기록하기"
            onClick={() => setOpen(true)}
          />

          {/* 오늘의 식단 기록 */}
          <div
            style={{
              width: "100%",
              padding: 16,
              background: "white",
              boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
              borderRadius: 16,
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <div style={titleText}>오늘의 식단 기록</div>

            {dietData.length === 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                  padding: "32px 0",
                }}
              >
                <div>
                  <IconEmptyDiet />
                </div>
                <p
                  style={{
                    color: "#A3A3A3",
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                    letterSpacing: "-0.28px",
                  }}
                >
                  식단 기록이 없어요
                </p>
              </div>
            )}

            {Array.isArray(dietData) &&
              dietData?.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: "white",
                      borderRadius: 16,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      item.aiYn === true
                        ? navi("/diet/write/AI", {
                            state: {
                              mealType: item.mealType,
                              date: formattedDate,
                            },
                          })
                        : navi("/diet/write", {
                            state: {
                              mealType: item.mealType,
                              date: formattedDate,
                            },
                          })
                    }
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 12 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: 80,
                          height: 80,
                          position: "relative",
                          borderRadius: 16,
                          overflow: "hidden",
                          background: "var(--neutral-100, #F5F5F5)",
                        }}
                      >
                        {item.fileUrl ? (
                          <FallbackImage
                            src={
                              process.env.REACT_APP_API_FILE +
                              (item.groupedDetails?.[0]?.fileUrl || "")
                            }
                            alt={item.meal}
                          />
                        ) : (
                          <IconNoimg />
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <div style={titleText}>{item.mealType}</div>
                          {item.aiYn === true && (
                            <div
                              style={{
                                background: "#FFEEDA",
                                padding: "2px 4px",
                                borderRadius: 4,
                                color: "#E66F00",
                                fontSize: 12,
                                fontWeight: 700,
                              }}
                            >
                              AI 분석
                            </div>
                          )}
                        </div>
                        <div style={subtitleText}>
                          {item.mealName || "기록없음"}
                        </div>
                        {item.totalCalorie ? (
                          <div style={titleText}>
                            총 {item.totalCalorie.toLocaleString()} Kcal
                          </div>
                        ) : (
                          <div style={titleText}>-</div>
                        )}
                      </div>
                    </div>
                    <IconRightArrow />
                  </div>
                );
              })}
          </div>
        </div>
        {completMedi && (
          <PopupEmotion title="기록 완료!" setClick={setCompletMedi} />
        )}
        {/* 모달 */}
        {open && (
          <ModalDietNote
            setOpen={setOpen}
            titleText={titleText}
            subtitleText={subtitleText}
            formattedDate={formattedDate}
          />
        )}

        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};

export const FallbackImage = ({
  src,
  alt,
  profile,
}: {
  src: string;
  alt: string;
  profile?: boolean;
}) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  if (error) {
    return <IconNoimg />;
  }

  return (
    <>
      {profile === true ? (
        <img
          src={src}
          alt="프로필"
          width={"52px"}
          height={"52px"}
          onError={() => setError(true)}
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "50%",
            objectFit: "cover",
            display: "block",
          }}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          onError={() => setError(true)}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 16,
            objectFit: "cover",
          }}
        />
      )}
    </>
  );
};
